import Cookies from 'js-cookie';
import formJson from 'form-json';

export function initializeCart() {
  const cart = document.getElementById('shopify-section-cart');
  const cartMain = document.getElementById('cart-container-main');

  let freeSampleContainerMain = null

  if (cartMain != null) {
    freeSampleContainerMain = cartMain.querySelector('.free-sample');
  };

  fetch('/cart.js', { method: 'GET' })
    .then((res) => res.json())
    .then((res) => {
      // Calculate total price
      const subtotal = getCurrencyString(res.total_price, res.currency);

      const activeGiftProduct = setActiveGiftProduct(res);

      const discountedItems = res.items.filter(item => {
        if (item.properties) {
          return item.properties['__discounted']
        }
        return {}
      });

      if(!discountedItems.length && res.attributes.byok){
        removeCartBundleAttribute();
      }

      if (window.giftProducts.length) {
        handleGiftProduct(res);
      }

      // Update layout
      const freeSampleLabel = cart.querySelector('header h6');
      const freeSampleContainer = cart.querySelector('.free-sample');
      const freeSampleItems = freeSampleContainer.querySelectorAll('.item');
      const orderSummaryEl = cart.querySelector('footer');
      const itemContainer = cart.querySelector('.cart-container .items');
      const navCartCountEl = document.querySelector('#shopify-section-menu-bar .cart text');
      navCartCountEl.innerHTML = res.item_count;
      const cartCountEl = cart.querySelector('header h1 span');
      cartCountEl.innerText = res.item_count;
      const subtotalEl = cart.querySelector('footer .subtotal p');
      subtotalEl.innerText = subtotal;
      subtotalEl.dataset.value = res.total_price;

      removeChildren(itemContainer);
      if (res.items.length === 0) {
        itemContainer.innerHTML = '<p class="empty">Your shopping cart is empty</p>';
        freeSampleLabel.style.display = 'none';
        freeSampleContainer.classList.add('hidden');
        orderSummaryEl.classList.add('hidden');
      } else {
        freeSampleLabel.style.display = 'block';
        freeSampleContainer.classList.remove('hidden');
        orderSummaryEl.classList.remove('hidden');

        let items_count = 0;
        let gifts_count = 0;

        res.items.forEach((item) => {
          const productName = item.product_title.toLowerCase().includes('auto renew')
            ? item.product_title.slice(0, -11)
            : item.product_title;
          const img = item.image
            ? item.image
            : 'https://cdn.shopify.com/s/files/1/0287/4019/0267/files/Missing-Assets.jpg?v=1586456716';
          let url = item.url;

          let subFrequency;
          let subUnit;
          let isFreeSample;
          let isGiftProduct = false;

          items_count++
          if (item.title.toLowerCase().includes('gift')) {
            gifts_count++
          };

          if (item.properties) {
            subFrequency = item.properties.shipping_interval_frequency;
            subUnit = item.properties.shipping_interval_unit_type;
            isFreeSample = item.properties.free_sample;
          }

          // if (activeGiftProduct && item.id === activeGiftProduct.variant_id || item.id === window.giftProductID) {
          //   isGiftProduct = true;
          // }

          var prefixClass;
          window.giftProducts.forEach(giftProduct => {
            if (item.id === giftProduct.variant_id) {
              isGiftProduct = true;
              prefixClass = giftProduct.variant_id
            };
          });

          if (activeGiftProduct && isGiftProduct && activeGiftProduct.link !== '') {
            url = activeGiftProduct.link;
          }

          // Disable add sample button if one already added
          if (isFreeSample) {
            freeSampleContainer.classList.add('hidden');
          }

          // Add product description
          let subtitle = '';
          if (subFrequency) {
            subtitle += `<p>Quantity: ${item.quantity} - ${getCurrencyString(
              item.final_price,
              res.currency
            )}</p>`;
          }

          item.options_with_values.forEach((option, index) => {
            if (option.name === 'Ingredient' || option.name === 'Color') {
              subtitle += `<p>Color: ${item.variant_options[index]}</p>`;
            } else if (option.name !== 'Title') {
              subtitle += `<p>${option.name}: ${item.variant_options[index]}</p>`;
            }
          });

          const isItemGift = item.properties != null && item.properties['__gift']
          const isItemFreeGift = item.properties != null && item.properties['__freegiftitem']
          // item.properties['__freegiftitem']

          if (subFrequency) {
            subtitle += `<p>Next shipment: ${getNextSubscription(
              parseInt(subFrequency)
            )} - Every ${subFrequency} ${subUnit.toLowerCase()}</p>`;
          } else if (!isFreeSample && !isItemGift || !isItemFreeGift) {
            if(item.properties && item.properties['__hidden']){
              subtitle += `
                  <div class="adjust-quantity">
                    <p>${item.quantity < 10 ? '0' : ''}${item.quantity}</p>
                  </div>
                `;
            } else if (isGiftProduct || isFreeSample) {
              subtitle += `
                  <div class="adjust-quantity">
                    <p>${item.quantity < 10 ? '0' : ''}${item.quantity}</p>
                  </div>
                `;
            } else {
              subtitle += `
                  <div class="adjust-quantity ${item.properties['__kit_item_title'] ? 'hidden' : ''} ${item.properties['__freegiftitem'] ? 'hidden' : ''}" data-handle="${item.handle}">
                    <button class="minus">
                      <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#444" stroke-width="2" d="M12 1H0"/>
                      </svg>
                    </button>
                    <p>${item.quantity < 10 ? '0' : ''}${item.quantity}</p>
                    <button class="plus">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#444" stroke-width="2" d="M6 0v12M12 6H0"/>
                      </svg>
                    </button>
                  </div>
                `;
            }
          }

          // Create element
          const el = document.createElement('div');
          el.classList.add('minicart-item');
          let variantName = '';

          if (item.properties['__freegiftitem'] || item.properties['__kit_item_title'] || item.properties['__kitparent']) {
            el.classList.add('bundle-item');
            el.setAttribute('data-id', item.id);
            el.setAttribute('data-kitid', item.properties['__byotk_id']);
          };

          if (item.variant_options[0] != 'Default Title' && item.variant_title != null) {
            variantName = ' ' + item.variant_title;
          }

          if (isGiftProduct) {
            el.classList.add('js-cart-product-gift');
            el.classList.add('line-item--gift');
            el.classList.add('line-item--'+prefixClass);
          }

          if (activeGiftProduct && activeGiftProduct.link !== '') {
            el.classList.add('line-item--gift-link');
          }

          let giftMess = isGiftProduct && window.giftMessage !== undefined ? '<p class="cart-gift-message">' + window.giftMessage + '</p>' : '';

          if (item.properties && item.properties.__gift) {
            giftMess = isGiftProduct && window.giftBundleMessage !== undefined ? '<p class="cart-gift-message">' + window.giftBundleMessage + '</p>' : '';
          }

          let hiddenClass = '';

          if (item.properties['__kit_item_title']) {
            hiddenClass = 'hidden';
          };

          el.innerHTML = `
              <div>
                <a href="${url}">
                  <img src="${img}" alt="Korres${variantName} ${productName}">
                </a>
              </div>

              <div class="details">
                <h2>
                  <a href="${url}">
                    ${productName}
                  </a>
                </h2>

                ${subtitle}

                ${giftMess}
              </div>

              <div class="push ${item.properties['__freegiftitem'] ? 'freegift' : ''} ${item.properties['__kitparent'] ? 'kit-parent' : ''}">
                <button data-bundle="${item.properties['__byotk_id']}" ${item.properties && item.properties['__gift'] || item.properties['__kit_item_title'] || item.properties['__freegiftitem'] ? 'class="hidden"' : ''}>- Remove</button>

                <p>${item.final_price < item.price ? '<s>' + getCurrencyString(item.price, res.currency) + '</s> ' : ''}${item.final_price > 0 ? getCurrencyString(item.final_price, res.currency) : 'Free'}</p>
              </div>
            `;


          // Attach event listeners
          // Remove item from cart
          el.querySelector('.push button').addEventListener('click', () => {
            var bundleKitId = el.dataset.kitid;

            const isParent = el.querySelector('.kit-parent');
            const countEl = el.querySelector('.adjust-quantity p');
            let count = 1;
            if (countEl) count = parseInt(countEl.innerText);
            const linePrice = parseMoneyToFloat(item.final_price.toString()) * count;
            const currentValue = parseMoneyToFloat(subtotalEl.dataset.value);
            const newValue = currentValue - linePrice;
            let newValueStr = `${newValue}${newValue % 1 === 0 ? '00' : ''}`;

            el.remove();

            navCartCountEl.innerHTML = `${parseInt(cartCountEl.innerText) - count}`;
            cartCountEl.innerText = `${parseInt(cartCountEl.innerText) - count}`;
            subtotalEl.innerText = getCurrencyString(newValueStr, res.currency);
            subtotalEl.dataset.value = newValueStr;

            if (parseInt(cartCountEl.innerHTML) < 1) {
              itemContainer.innerHTML = '<p class="empty">Your shopping cart is empty</p>';
              freeSampleContainer.classList.add('hidden');
              orderSummaryEl.classList.add('hidden');
            }

            if (isFreeSample) {
              freeSampleContainer.classList.remove('hidden');
            }

            updateCartQuantity(item.id, 0, bundleKitId);
          });

          const minusBtn = el.querySelector('button.minus');
          const plusBtn = el.querySelector('button.plus');


          if (minusBtn && plusBtn) {
            const countEl = el.querySelector('.adjust-quantity p');

            var cartCounter = document.querySelector('#shopify-section-cart header h1 span')

            // Reduce quantity
            minusBtn.addEventListener('click', () => {
              let oldQty = parseInt(cartCounter.innerHTML);

              const count = parseInt(countEl.innerText) - 1;
              const currentValue = parseMoneyToFloat(subtotalEl.dataset.value);
              const newValue = (currentValue - parseMoneyToFloat(item.final_price.toString())).toFixed(2);
              let newValueStr = newValue.toString().match(/\d/g).join('');

              var bundleKitId = el.dataset.kitid;

              if (count < 1) {
                el.remove();
              } else {
                countEl.innerText = `${count < 10 ? '0' : ''}${count}`;
              }

              navCartCountEl.innerHTML = `${parseInt(cartCountEl.innerText) - 1}`;
              cartCountEl.innerText = `${parseInt(cartCountEl.innerText) - 1}`;
              subtotalEl.innerText = getCurrencyString(newValueStr, res.currency);
              subtotalEl.dataset.value = newValueStr;

              if (parseInt(cartCountEl.innerHTML) < 1) {
                itemContainer.innerHTML = '<p class="empty">Your shopping cart is empty</p>';
                freeSampleContainer.classList.add('hidden');
                orderSummaryEl.classList.add('hidden');
              }

              if (el.classList.contains('bundle-item')) {
                updateKitItems(res.items, count, el, oldQty, true)
              } else {
                updateCartQuantity(item.id, count);
              }
            });

            // Add quantity
            plusBtn.addEventListener('click', () => {
              let oldQty = parseInt(cartCounter.innerHTML);

              const count = parseInt(countEl.innerText) + 1;
              const currentValue = parseMoneyToFloat(subtotalEl.dataset.value);
              const newValue = (currentValue + parseMoneyToFloat(item.final_price.toString())).toFixed(2);
              let newValueStr = newValue.toString().match(/\d/g).join('');

              navCartCountEl.innerHTML = `${parseInt(cartCountEl.innerText) + 1}`;
              cartCountEl.innerText = `${parseInt(cartCountEl.innerText) + 1}`;
              countEl.innerText = `${count < 10 ? '0' : ''}${count}`;
              subtotalEl.innerText = getCurrencyString(newValueStr, res.currency);
              subtotalEl.dataset.value = newValueStr;

              if (el.classList.contains('bundle-item')) {
                updateKitItems(res.items, count, el, oldQty, false)
              } else {
                updateCartQuantity(item.id, count);
              }
            });
          }

          // Render element
          itemContainer.appendChild(el);
        });

        if (items_count === gifts_count) {
          freeSampleContainer.classList.add('hidden');
          if (freeSampleContainerMain != null) {
            freeSampleContainerMain.classList.add('hidden');
          };
        };

        if (window.miniUpsell !== undefined) {
          const miniUpsellHtml = document.createElement('div');
          miniUpsellHtml.innerHTML = `
                <div class="details upsell">
                  <h2 style="color: ${window.miniUpsell.color}; font-family: ${window.miniUpsell.font};">${window.miniUpsell.text}</h2>
                </div>
              `;

          itemContainer.prepend(miniUpsellHtml);
        }
      }
    });

    const updateEvent = new Event('cartupdate')
    window.dispatchEvent(updateEvent)

    if (Cookies.get('korres-gift-needs-refresh') === 'true') {
      Cookies.remove('korres-gift-needs-refresh');
      location.reload();
    }
}


// -------------- Helper Methods -------------- //
export function updateCartQuantity(id, quantity, kitbundleid) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      updates: { [id]: quantity }
    })
  })
    .then((res) => {
      if (res.ok) return res.json();
      else throw Error(`Request rejected with status ${res.status}`);
    })
    .then((res) => {
      initializeCart();

      // TRW 10/24/2020
      CustomWidgets.removeSampleFromCart(false,initializeCart,res) ;

      const giftProducts = res.items.filter(item => {
        if (item.properties) {
          return item.properties['__gift']
        }
        return {}
      });


      var onlyThisBundleArray = []

      res.items.forEach(thisitem => {
        var parsekitbundleid = parseInt(kitbundleid)
        var parsebyotk_id = parseInt(thisitem.properties['__byotk_id'])

        if (parsekitbundleid === parsebyotk_id) {
          onlyThisBundleArray.push(thisitem)
        };
      })

      if (onlyThisBundleArray.length) {
        removeItems(onlyThisBundleArray)
      };

      if(giftProducts.length){
        giftProducts.map(item => {
          const hasItems = res.items.filter(line_item => item.key !== line_item.key && item.properties.__hash === line_item.properties.__hash);
          if(!hasItems.length){
            updateCartQuantity(item.key, 0);
          }
        })
      }

      const discountedItems = res.items.filter(item => {
        if (item.properties) {
          return item.properties['__discounted']
        }

        return {}
      });

      if(!discountedItems.length && res.attributes.byok){
        removeCartBundleAttribute();
      }
    });
}

function removeItems(items) {
  const initialItems = document.querySelector('li.cart svg text').innerHTML;
  const newItems = initialItems - items.length

  var array = []

  items.forEach(item => {
    if (item.properties['__freegiftitem'] || item.properties['__kit_item_title'] || item.properties['__kitparent']) {
      array.push(item.id)
    };
  })

  // var itemsProcessed = items.slice(0,-1);
  var itemsArray = array;
  var qty = 0;
  var data = { updates: {} };

  for (var i = 0; i < itemsArray.length; i++) {
     data.updates[itemsArray[i]] = qty;
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function() {
      initializeCart();

      // Select the node that will be observed for mutations
      const targetNode = document.querySelector('li.cart svg text');

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {
          // Use traditional 'for loops' for IE 11
          for(const mutation of mutationsList) {
              if (mutation.type === 'childList') {
                const newCounter = parseInt(document.querySelector('li.cart svg text').innerHTML);
                if (newCounter === newItems) {
                  if (document.querySelector('body').classList.contains('cart')) {
                    window.location.reload();
                  };
                };
              }
          }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }
  });
}


function updateKitItems(kitItems, counter, parent, currentQty, isMinus) {
  var kitsId = [];
  let kitQty = 0;

  kitItems.forEach(kititem => {
    if (kititem.properties['__byotk_id'] == parent.dataset.kitid) {
      kitsId.push(kititem.id)

      if (isMinus) {
        kitQty--
      } else {
        kitQty++
      }
    };
  })

  var newQty = currentQty + kitQty;
  var miniCartCounter = document.querySelector('#shopify-section-cart header h1 span')
  var mainCartCounter = document.querySelector('.bm-nav li.cart svg text')

  miniCartCounter.innerHTML = newQty;
  mainCartCounter.innerHTML = newQty;

  // var itemsProcessed = items.slice(0,-1);
  var itemsArray = kitsId;
  var qty = counter;
  var data = { updates: {} };

  for (var i = 0; i < itemsArray.length; i++) {
     data.updates[itemsArray[i]] = qty;
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function() {
      initializeCart();

      setTimeout(function() {
        if (document.querySelector('body').classList.contains('cart')) {
          window.location.reload();
        };
      }, 100);
    }
  });
}

export function removeCartBundleAttribute() {
  fetch('/cart/update.js', {
    method: "post",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
        attributes: {
            byok: null
        }
    })
  })
}

export function parseMoneyToFloat(money) {
  return parseFloat(money.slice(0, -2) + '.' + money.slice(-2));
}

export function getCurrencyString(price, currency) {
  let total_price = price.toString();
  total_price = parseMoneyToFloat(total_price);
  return total_price.toLocaleString(undefined, { style: 'currency', currency: currency });
}

function removeChildren(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

function getNextSubscription(days) {
  let result = new Date();
  result.setDate(result.getDate() + days);
  return result.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

function addItem($form) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formJson($form))
  })
    .then((res) => {
      if (res.ok) return res.json();
      else throw Error(`Request rejected with status ${res.status}`);
    })
    .then((res) => {
      Cookies.set('korres-gift-is-added', true);

      initializeCart();
      this.body.classList.add('cart-open');
      document.getElementById('shopify-section-cart').classList.add('show');
    })
    .catch(console.log);
}

function addGiftItem($form, string, giftid) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formJson($form))
  })
    .then((res) => {
      if (res.ok) return res.json();
      else throw Error(`Request rejected with status ${res.status}`);
    })
    .then((res) => {
      Cookies.set(string, giftid);

      initializeCart();
      this.body.classList.add('cart-open');
      document.getElementById('shopify-section-cart').classList.add('show');
    })
    .catch(console.log);
}

function setActiveGiftProduct(res) {
  let activeGiftProduct = null;
  const hasGiftItem = Cookies.get('korres-gift-is-added');
  let giftProductQty = hasGiftItem ? 1 : 0;
  let triggerProduct = window.triggerProduct;
  let triggerProductInCart = false;
  let cartItems = res.items;
  cartItems.forEach(cartItem => {
    if (cartItem.id == triggerProduct.variant_id) {
      triggerProductInCart = true;
    }
  })

  for (const giftProduct of window.giftProducts) {
    if (typeof giftProduct === 'undefined') {
      break;
    }

    if (window.giftTrigger === 'price' && giftProduct.min_price * 100 < res.total_price) {
      activeGiftProduct = giftProduct;
      continue;
    }

    if (window.giftTrigger === 'quantity' && res.item_count - giftProductQty >= giftProduct.min_qty) {
      activeGiftProduct = giftProduct;
      continue;
    }

    if (window.giftTrigger === 'product' && triggerProductInCart) {
      activeGiftProduct = giftProduct;
      continue;
    }

    // if (Cookies.get('korres-gift-id') == giftProduct.variant_id) {
    //   activeGiftProduct = giftProduct;
    //   continue;
    // }

    break;
  }

  return activeGiftProduct;
}

function removeGift(cookieString, id) {
  var classString = '.line-item--'+id;
  var giftProductInCart = document.querySelector(classString);

  if (giftProductInCart != null) {
    var giftProductRemove = giftProductInCart.querySelector('.push button');

    giftProductRemove.click();

    setTimeout(function() {
      Cookies.remove(cookieString);

      setTimeout(function() {
        // Refresh cart page
        if (document.body.classList.contains('cart')) {
          location.reload();
        }
      }, 1400);
    }, 1000);
  };
}

function addGift(condition, cookieString, id, gift) {
  if (Cookies.get(cookieString, id) === undefined) {
    if (condition) {
      var giftForm = document.querySelector('.js-gift-form[data-handle="'+gift.product+'"]')
      // Cookies.set(cookieString, id);

      addGiftItem(giftForm, cookieString, id);

      setTimeout(function() {
        // Refresh cart page
        if (document.body.classList.contains('cart')) {
          location.reload();
        }
      }, 1400);
    }
  }
}

function handleGiftProduct(res) {
  if (window.giftStacking === 'stack') {
    var giftItems           = window.giftProducts;
    var cartItems           = res.items;
    var giftsIncart         = false;
    var giftProductsInCart  = 0;

    cartItems.forEach(cartItem => {
      giftItems.forEach(giftItem => {
        if (giftItem.variant_id === cartItem.variant_id) {
          giftProductsInCart++
        };
      });
    });

    // Get the quantity of all non gift products in cart
    var nonGiftProducts     = res.item_count - giftProductsInCart

    giftItems.forEach(giftItem => {
      var totalPrice        = res.total_price/100;
      var giftCookieString  = giftItem.product;
      var giftVariant_id    = giftItem.variant_id;
      var priceMore         = totalPrice > giftItem.min_price;
      var priceLess         = totalPrice < giftItem.min_price;
      var qtyMore           = nonGiftProducts >= giftItem.min_qty;
      var qtyLess           = nonGiftProducts < giftItem.min_qty;
      let triggerProductInCart = false;
      let triggerProduct    = window.triggerProduct;
      if (giftProductsInCart < 1) {
        Cookies.remove(giftCookieString)
      };

      cartItems.forEach(item => {
        item.id == triggerProduct.variant_id ? triggerProductInCart = true : triggerProductInCart = false;
      })

      cartItems.forEach(cartItem => {
        var isCartItem = giftItem.variant_id === cartItem.variant_id;
        var notCartItem = giftItem.variant_id != cartItem.variant_id;

        // Conditions for minimum price
        if (window.giftTrigger === 'price') {
          // Remove gift from minicart
          if (priceLess && isCartItem) {
            removeGift(giftCookieString, giftItem.variant_id)
          };

          // Add gift to minicart
          if (notCartItem) {
            var giftisnotadded = true;

            cartItems.forEach(cartItem => {
              if (cartItem.handle === giftCookieString) {
                giftisnotadded = false;
              };
            });

            if (giftisnotadded) {
              Cookies.remove(giftCookieString)
            };

            addGift(priceMore, giftCookieString, giftVariant_id, giftItem)
          }
        };

        // Conditions for minimum quantity
        if (window.giftTrigger === 'quantity') {
          // Remove gift from minicart
          if (qtyLess && isCartItem) {
            removeGift(giftCookieString, giftItem.variant_id)
          };

          // Add gift to minicart
          if (notCartItem) {
            addGift(qtyMore, giftCookieString, giftVariant_id, giftItem)
          };
        };
        
        // Conditions for trigger product
        if (window.giftTrigger === 'product') {
          // Remove gift from minicart
          if (!triggerProductInCart) {
            removeGift(giftCookieString, giftItem.variant_id)
          };

          let giftIsNotAdded = true;

          cartItems.forEach(cartItem => {
            if (cartItem.handle === giftCookieString) {
              giftIsNotAdded = false;
            };
          });

          if (giftIsNotAdded) {
            Cookies.remove(giftCookieString)
          };

          // Add gift to minicart
          if (triggerProductInCart && giftIsNotAdded) {
            addGift(triggerProductInCart, giftCookieString, giftVariant_id, giftItem)
          };
        };
      });
    });
  } else {
    let giftProductIds = [];
    let giftsInCart = 0;

    window.giftProducts.forEach(giftProduct => {
      giftProductIds.push(giftProduct.variant_id)
    });

    res.items.forEach(item => {
      var item_variant_id = item.variant_id

      if (giftProductIds.includes(item_variant_id)) {
        giftsInCart++
      };
    });

    if (giftsInCart < 1) {
      Cookies.remove('korres-gift-is-added');
    };

    const freeProductId = document.getElementById('freeProduct').dataset.freegift;

    const notFreeOrGift = res.items.filter(item => {
      if (item.product_id === freeProductId || item.product_title.toLowerCase().includes('gift')) {

      } else {
        return item.product_id
      }
    });

    if (notFreeOrGift.length > 0 ) {
      if (document.querySelector('.js-cart-product-gift')) {
        Cookies.set('korres-gift-is-added', true);
      }

      // Set gift product
      const activeGiftProduct = setActiveGiftProduct(res);

      // If there is no gift item added.
      if (
        Cookies.get('korres-gift-is-added') === undefined &&
        !document.querySelector('.js-cart-product-gift') &&
        activeGiftProduct
      ) {
        const form = document.querySelector(activeGiftProduct.selector);
        addItem(form);
        Cookies.set('korres-gift-id', activeGiftProduct.variant_id);

        // Refresh cart page
        if (document.body.classList.contains('cart')) {
          Cookies.set('korres-gift-needs-refresh', true);
        }
      }

      // If there is a gift item added. Check if it needs to be updated with another one.
      if (
        Cookies.get('korres-gift-is-added') === 'true' &&
        document.querySelector('.js-cart-product-gift') &&
        activeGiftProduct
      ) {
        if (Cookies.get('korres-gift-id') !== String(activeGiftProduct.variant_id)) {
          document.querySelector('.js-cart-product-gift .push button').click();

          setTimeout(() => {
            const form = document.querySelector(activeGiftProduct.selector);
            addItem(form);
            Cookies.set('korres-gift-id', activeGiftProduct.variant_id);

            // Refresh cart page
            if (document.body.classList.contains('cart')) {
              Cookies.set('korres-gift-needs-refresh', true);
            }
          }, 500);
        }
      }

      // If there is a gift item that needs to be removed.
      if (
        Cookies.get('korres-gift-is-added') === 'true' &&
        document.querySelector('.js-cart-product-gift') &&
        !activeGiftProduct
      ) {
        // Remove gift item based on trigger
        document.querySelector('.js-cart-product-gift .push button').click();

        Cookies.remove('korres-gift-is-added');
        Cookies.remove('korres-gift-id');

        // Refresh cart page
        if (document.body.classList.contains('cart')) {
          Cookies.set('korres-gift-needs-refresh', true);
        }
      }
    } else {
      setTimeout(function() {
        const jsCartGiftBtn =  document.querySelector('.js-cart-product-gift .push button') !== null;

        if (jsCartGiftBtn) {
          Cookies.remove('korres-gift-is-added');
          document.querySelector('.js-cart-product-gift .push button').click();
        };
      }, 1000);
    }
  }
}

